module.exports = __webpack_public_path__ + "static/img/idcard1.be872106.png";